import {getDatapointDisplayValue, getItemIdentifier} from './config/ConfigUtils';
import {getDisplayValue, translateCustomTokens} from './InfoWidgetUtils';
import {InfoWidgetItem, InfoWidgetValueItem, isInfoWidgetDatapoint} from './types';
import {Datapoint} from '@deviceinsight/ng-ui-api-client';
import {TFunction} from '@deviceinsight/ng-ui-scale-lib/api';

type Props = {
	items: Array<InfoWidgetItem>;
	values: Array<InfoWidgetValueItem>;
	t: TFunction;
	className: string;
};
type DisplayProps = {
	value: any;
	t: TFunction;
};
type ItemDisplayProps = {
	item: InfoWidgetItem;
	valueItems: Array<InfoWidgetValueItem>;
	t: TFunction;
};
type DatapointDisplayProps = DisplayProps & {
	label: string;
	datapoint: Datapoint | null | undefined;
	decimalPoints: number | null | undefined;
};
type PropertyDisplayProps = DisplayProps & {
	label: string;
	propertyKey: string;
};

const DatapointDisplay = ({label, value, datapoint, decimalPoints, t}: DatapointDisplayProps) => {
	const datapointName = datapoint ? datapoint.name : '';
	const translatedLabel = translateCustomTokens(label ? label : datapointName, t);
	const displayValue = getDatapointDisplayValue(datapoint, decimalPoints || 0, value);
	return (
		<div className="info-display-item">
			<span title={translatedLabel}>{translatedLabel}:</span>
			<label title={displayValue}>{displayValue}</label>
		</div>
	);
};

const PropertyDisplay = ({label, propertyKey, value, t}: PropertyDisplayProps) => {
	const translatedLabel = translateCustomTokens(label ? label : propertyKey, t);
	const displayValue = getDisplayValue(value);
	return (
		<div className="info-display-item">
			<span>{translatedLabel}:</span>
			<label title={displayValue}>{displayValue}</label>
		</div>
	);
};

const ItemDisplay = ({item, valueItems, t}: ItemDisplayProps) => {
	const valueItem = valueItems.find(
		(valueItem) => valueItem.type === item.type && valueItem.identifier === getItemIdentifier(item)
	);
	const value = valueItem ? valueItem.value : '';

	if (isInfoWidgetDatapoint(item)) {
		return (
			<DatapointDisplay
				value={value}
				datapoint={item.datapoint}
				decimalPoints={item.decimalPoints}
				label={item.label}
				t={t}
			/>
		);
	} else {
		return <PropertyDisplay value={value} label={item.label} propertyKey={item.propertyKey || ''} t={t} />;
	}
};

const InfoWidgetRegular = ({items, values, t, className}: Props) => {
	return (
		<div className={className}>
			{items.map((item, index) => (
				<ItemDisplay t={t} item={item} valueItems={values} key={`item_${index}`} />
			))}
		</div>
	);
};

export default InfoWidgetRegular;
